import React, { Component } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import routers from './routers'

export default class CRouter extends Component {
    requireAuth = (permission, component) => {
        const { auth } = this.props;
        const { permissions } = auth.data;

        if (!permissions || !permissions.includes(permission)) return <Redirect to={'404'} />;
        return component;
    };

    render() {
        return (
            <Switch>
                {routers.map((e, i) => (
                    <Route
                        key={i}
                        path={e.path}
                        exact={e.exact}
                        component={e.component}
                    />
                ))}
                <Route render={() => <Redirect to="/404" />} />
            </Switch>
        )
    }
}


// WEBPACK FOOTER //
// ./src/routes/index.js